import { Component, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-tradingview-widget',
    templateUrl: './tradingview-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './tradingview-widget.component.scss'],
    standalone: false
})
export class TradingViewWidgetComponent extends BaseWidgetComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tvContainer', { static: false }) tvContainer: ElementRef;

  public embedUrl: SafeResourceUrl;
  private _symbol: string = 'NASDAQ:AAPL';

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit(): void {
    this.buildEmbedUrl();
  }

  ngAfterViewInit(): void {
    // Container ready
  }

  private buildEmbedUrl(): void {
    const config = {
      autosize: true,
      symbol: this._symbol,
      interval: 'D',
      timezone: 'America/Chicago',
      theme: 'dark',
      style: '1',  // Candlestick
      locale: 'en',
      allow_symbol_change: true,
      calendar: false,
      support_host: 'https://www.tradingview.com'
    };

    const encodedConfig = encodeURIComponent(JSON.stringify(config));
    const url = `https://s.tradingview.com/widgetembed/?hideideas=1&overrides={}&enabled_features=[]&disabled_features=[]&locale=en#${encodedConfig}`;
    this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
